/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/alt-text */
import { useEffect, useState } from "react";
import image from "../../assets/images/NewLogo.png";
import loginImg from "../../assets/images/loginone.png";
import logo from "../../assets/images/newlogo2.png";
import signIn from "../../assets/images/signIn.svg";
import styles from "../header/Header.module.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";

const Header = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const location = useLocation();
  const navigate = useNavigate();
  // Function to update the state with the current screen width
  const updateScreenWidth = () => {
    setScreenWidth(window.innerWidth);
  };

  // Add an event listener to update the width when the window is resized

  useEffect(() => {
    window.addEventListener("resize", updateScreenWidth);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", updateScreenWidth);
    };
  }, []);

  return (
    <Container>
      <div className={styles.header_start}>
        <div className={styles.left_header}>
          <nav className="navbar navbar-expand-lg navbar-light w-100">
            <div className="container-fluid">
              <div
                onClick={() => {
                  navigate("/");
                }}
                className={styles.logo_header}
              >
                <img style={{ cursor: "pointer" }} src={logo} />
                <div className={styles.logo_text}>
                  <p>THE INSPECTION</p>
                  <span>COMPANY</span>
                </div>
              </div>
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className="collapse navbar-collapse justify-content-between"
                id="navbarSupportedContent"
              >
                <div className={styles.links}>
                  <ul className="navbar-nav me-auto mb-1 mb-lg-0">
                    <li
                      className={`nav-item ${
                        location.pathname === "/" ? styles.active : ""
                      }`}
                    >
                      <Link to="/" className={styles.home}>
                        Home
                      </Link>
                    </li>
                    <li
                      className={`nav-item ${
                        location.pathname === "/aboutus" ? styles.active : ""
                      }`}
                    >
                      <Link className={styles.about_us} to="/aboutus">
                        About us
                      </Link>
                    </li>

                    <li
                      className={`nav-item ${
                        location.pathname.includes("blog") ? styles.active : ""
                      }`}
                    >
                      <Link className={styles.blog} to="/blogs">
                        Blogs
                      </Link>
                    </li>

                    <li
                      className={`nav-item ${
                        location.pathname === "/contactus" ? styles.active : ""
                      }`}
                    >
                      <Link className={styles.about_us} to="/contactus">
                        Contact us
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className={styles.signupForm}>
                  <div className={styles.signup}>
                    <Link
                      to="https://vendor.cidusa.net/register"
                      target="_blank"
                    >
                      <button type="button">
                        <img src={signIn} className="me-2" />
                        SIGN UP
                      </button>
                    </Link>
                  </div>
                  <div className={styles.signup}>
                    <Link to="https://vendor.cidusa.net" target="_blank">
                      <button type="button">
                        <img src={signIn} className="me-2" />
                        SIGN IN
                      </button>
                    </Link>
                  </div>
                  <div className={styles.appointment}>
                    <button
                      onClick={() => {
                        navigate("/contactus");
                      }}
                      type="button"
                      data-bs-toggle="tooltip"
                      data-bs-placement="right"
                      title="Call us on 11111122"
                    >
                      SCHEDULE INSPECTION
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </Container>
  );
};
export default Header;
